import { IconType } from '@kinomap-dev/ng-ui-lib/core';
import { ContentType } from '../pages/content-creation/content-creation';

export const CONTENT_TYPE_ICONS: Record<ContentType, IconType> = {
    scenic: 'video',
    'gps-only': 'gps_stroke',
    coaching: 'coaching_stroke',
    workout: 'workout_stroke',
    playlist: 'playlists',
} as const;

export function contentTypeToIcon(type: ContentType): IconType {
    return CONTENT_TYPE_ICONS[type];
}
